// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/sections/Hero.css */
.hero {
  min-height: 100vh;
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
  padding-top: 100px;
}

.hero-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
}

.hero-gradient-1 {
  position: absolute;
  width: 600px;
  height: 600px;
  background: radial-gradient(circle, rgba(0, 242, 254, 0.3) 0%, transparent 70%);
  filter: blur(60px);
  top: -200px;
  right: -200px;
}

.hero-gradient-2 {
  position: absolute;
  width: 800px;
  height: 800px;
  background: radial-gradient(circle, rgba(79, 172, 254, 0.3) 0%, transparent 70%);
  filter: blur(80px);
  bottom: -300px;
  left: -300px;
}

.hero-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
  min-height: calc(100vh - 100px);
}

.hero-content {
  z-index: 2;
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 20px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 50px;
  font-size: 0.9rem;
  margin-bottom: 30px;
  color: var(--primary-color);
}

.hero-badge svg {
  color: var(--accent-color);
}

.hero-title {
  font-size: clamp(2.5rem, 5vw, 4rem);
  font-weight: 800;
  margin-bottom: 20px;
  line-height: 1.1;
}

.hero-title::first-line {
  background: var(--gradient-primary);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.hero-subtitle {
  font-size: 1.25rem;
  color: var(--text-secondary);
  margin-bottom: 40px;
  max-width: 500px;
}

.hero-buttons {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.hero-visual {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.floating-elements {
  position: absolute;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.floating-element {
  position: absolute;
  border-radius: 50%;
  background: var(--gradient-primary);
  opacity: 0.6;
  filter: blur(40px);
}

.element-1 {
  width: 150px;
  height: 150px;
  top: 20%;
  left: 10%;
}

.element-2 {
  width: 200px;
  height: 200px;
  bottom: 20%;
  right: 10%;
  background: var(--gradient-accent);
}

.element-3 {
  width: 100px;
  height: 100px;
  top: 50%;
  right: 30%;
}

.code-window {
  background: rgba(26, 26, 26, 0.95);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  overflow: hidden;
  width: 100%;
  max-width: 500px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(10px);
  transform: perspective(1000px) rotateY(-5deg);
  transition: transform 0.3s ease;
}

.code-window:hover {
  transform: perspective(1000px) rotateY(0deg);
}

.window-header {
  background: rgba(40, 40, 40, 0.95);
  padding: 12px 20px;
  display: flex;
  align-items: center;
  gap: 15px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.window-controls {
  display: flex;
  gap: 8px;
}

.control {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  cursor: pointer;
  transition: var(--transition-smooth);
}

.control.red {
  background: #ff5f56;
}

.control.yellow {
  background: #ffbd2e;
}

.control.green {
  background: #27c93f;
}

.control:hover {
  transform: scale(1.1);
}

.window-title {
  font-size: 0.9rem;
  color: var(--text-secondary);
}

.window-content {
  padding: 20px;
}

.window-content pre {
  margin: 0;
  font-family: 'Courier New', monospace;
  font-size: 0.9rem;
  line-height: 1.6;
  color: var(--primary-color);
}

.scroll-indicator {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  color: var(--text-secondary);
  opacity: 0.6;
  cursor: pointer;
  transition: var(--transition-smooth);
}

.scroll-indicator:hover {
  opacity: 1;
  color: var(--primary-color);
}

/* Responsive */
@media (max-width: 968px) {
  .hero-container {
    grid-template-columns: 1fr;
    text-align: center;
  }

  .hero-content {
    order: 2;
  }

  .hero-visual {
    order: 1;
    margin-bottom: 40px;
  }

  .hero-subtitle {
    margin: 0 auto 40px;
  }

  .hero-buttons {
    justify-content: center;
  }

  .code-window {
    max-width: 400px;
    transform: none;
  }

  .floating-element {
    display: none;
  }
}

@media (max-width: 480px) {
  .hero-title {
    font-size: 2rem;
  }

  .hero-subtitle {
    font-size: 1rem;
  }

  .code-window {
    max-width: 100%;
  }

  .window-content pre {
    font-size: 0.8rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/sections/Hero.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,+EAA+E;EAC/E,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,gFAAgF;EAChF,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mCAAmC;EACnC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,2BAA2B;EAC3B,6CAA6C;EAC7C,+BAA+B;AACjC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,4BAA4B;EAC5B,YAAY;EACZ,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* src/components/sections/Hero.css */\n.hero {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  position: relative;\n  overflow: hidden;\n  padding-top: 100px;\n}\n\n.hero-background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: -1;\n}\n\n.hero-gradient-1 {\n  position: absolute;\n  width: 600px;\n  height: 600px;\n  background: radial-gradient(circle, rgba(0, 242, 254, 0.3) 0%, transparent 70%);\n  filter: blur(60px);\n  top: -200px;\n  right: -200px;\n}\n\n.hero-gradient-2 {\n  position: absolute;\n  width: 800px;\n  height: 800px;\n  background: radial-gradient(circle, rgba(79, 172, 254, 0.3) 0%, transparent 70%);\n  filter: blur(80px);\n  bottom: -300px;\n  left: -300px;\n}\n\n.hero-container {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 60px;\n  align-items: center;\n  min-height: calc(100vh - 100px);\n}\n\n.hero-content {\n  z-index: 2;\n}\n\n.hero-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 20px;\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 50px;\n  font-size: 0.9rem;\n  margin-bottom: 30px;\n  color: var(--primary-color);\n}\n\n.hero-badge svg {\n  color: var(--accent-color);\n}\n\n.hero-title {\n  font-size: clamp(2.5rem, 5vw, 4rem);\n  font-weight: 800;\n  margin-bottom: 20px;\n  line-height: 1.1;\n}\n\n.hero-title::first-line {\n  background: var(--gradient-primary);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.hero-subtitle {\n  font-size: 1.25rem;\n  color: var(--text-secondary);\n  margin-bottom: 40px;\n  max-width: 500px;\n}\n\n.hero-buttons {\n  display: flex;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n.hero-visual {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.floating-elements {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n}\n\n.floating-element {\n  position: absolute;\n  border-radius: 50%;\n  background: var(--gradient-primary);\n  opacity: 0.6;\n  filter: blur(40px);\n}\n\n.element-1 {\n  width: 150px;\n  height: 150px;\n  top: 20%;\n  left: 10%;\n}\n\n.element-2 {\n  width: 200px;\n  height: 200px;\n  bottom: 20%;\n  right: 10%;\n  background: var(--gradient-accent);\n}\n\n.element-3 {\n  width: 100px;\n  height: 100px;\n  top: 50%;\n  right: 30%;\n}\n\n.code-window {\n  background: rgba(26, 26, 26, 0.95);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n  overflow: hidden;\n  width: 100%;\n  max-width: 500px;\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(10px);\n  transform: perspective(1000px) rotateY(-5deg);\n  transition: transform 0.3s ease;\n}\n\n.code-window:hover {\n  transform: perspective(1000px) rotateY(0deg);\n}\n\n.window-header {\n  background: rgba(40, 40, 40, 0.95);\n  padding: 12px 20px;\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.window-controls {\n  display: flex;\n  gap: 8px;\n}\n\n.control {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: var(--transition-smooth);\n}\n\n.control.red {\n  background: #ff5f56;\n}\n\n.control.yellow {\n  background: #ffbd2e;\n}\n\n.control.green {\n  background: #27c93f;\n}\n\n.control:hover {\n  transform: scale(1.1);\n}\n\n.window-title {\n  font-size: 0.9rem;\n  color: var(--text-secondary);\n}\n\n.window-content {\n  padding: 20px;\n}\n\n.window-content pre {\n  margin: 0;\n  font-family: 'Courier New', monospace;\n  font-size: 0.9rem;\n  line-height: 1.6;\n  color: var(--primary-color);\n}\n\n.scroll-indicator {\n  position: absolute;\n  bottom: 30px;\n  left: 50%;\n  transform: translateX(-50%);\n  color: var(--text-secondary);\n  opacity: 0.6;\n  cursor: pointer;\n  transition: var(--transition-smooth);\n}\n\n.scroll-indicator:hover {\n  opacity: 1;\n  color: var(--primary-color);\n}\n\n/* Responsive */\n@media (max-width: 968px) {\n  .hero-container {\n    grid-template-columns: 1fr;\n    text-align: center;\n  }\n\n  .hero-content {\n    order: 2;\n  }\n\n  .hero-visual {\n    order: 1;\n    margin-bottom: 40px;\n  }\n\n  .hero-subtitle {\n    margin: 0 auto 40px;\n  }\n\n  .hero-buttons {\n    justify-content: center;\n  }\n\n  .code-window {\n    max-width: 400px;\n    transform: none;\n  }\n\n  .floating-element {\n    display: none;\n  }\n}\n\n@media (max-width: 480px) {\n  .hero-title {\n    font-size: 2rem;\n  }\n\n  .hero-subtitle {\n    font-size: 1rem;\n  }\n\n  .code-window {\n    max-width: 100%;\n  }\n\n  .window-content pre {\n    font-size: 0.8rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
